import { useState, useEffect } from 'react'
import clsx from 'clsx'
import { CHAIN_ICON_KEY_MAP } from '@/constants/chain'

const PLACEHOLDER_ICON =
  'https://d2refp30laz1gf.cloudfront.net/icon/coin/coin_placeholder.svg'

export default function IconChain({ id = '', ...props }) {
  props = {
    ...props,
    className: clsx(props.className, 'chain-icon')
  }
  const [isError, setIsError] = useState(false)
  const onError = () => {
    if (isError) {
      return
    }
    setIsError(true)
  }

  useEffect(() => setIsError(false), [id])

  const key = CHAIN_ICON_KEY_MAP[id]
  const src = isError ? PLACEHOLDER_ICON : `/static/img/chain/${key}.svg`
  const alt = `${key} chain icon`

  return <img {...props} src={src} alt={alt} onError={onError} />
}
